// components/PgFormModal.jsx

import React from "react";
import {
 Modal,
 ModalOverlay,
 ModalContent,
 ModalCloseButton,
 ModalBody,
 useDisclosure,
 Button,
 Box,
 useToast,
} from "@chakra-ui/react";
import PgInquiryForm from "./PgInquiryForm";

const PgFormModal = () => {
 const { isOpen, onOpen, onClose } = useDisclosure();
 const toast = useToast();

 const handleSuccess = () => {
  onClose();
  toast({
   title: "Submitted successfully.",
   description: "Our team will contact you shortly.",
   status: "success",
   duration: 5000,
   isClosable: true,
  });
 };

 return (
  <Box>
   <Button colorScheme="blue" onClick={onOpen}>
    Apply for PG
   </Button>

   <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
    <ModalOverlay />
    <ModalContent>
     <ModalCloseButton />
     <ModalBody>
      <PgInquiryForm onSuccess={handleSuccess} />
     </ModalBody>
    </ModalContent>
   </Modal>
  </Box>
 );
};

export default PgFormModal;
